import { createI18n } from "vue-i18n"
import messages from "@/i18n/messages"
import { datetimeFormats } from "@/i18n/datetimeFormats"
import "@/i18n/yup/yup-validators"

enum languages {
  "en-US" = "en",
  "pt-BR" = "pt",
  "es-ES" = "es"
}

const storedLanguage = localStorage.getItem("lang")
const browserLanguage =
  languages[window.navigator.language as keyof typeof languages]
const currentLocale = storedLanguage ? storedLanguage : browserLanguage

export const i18n = createI18n({
  locale: currentLocale || "en",
  messages,
  datetimeFormats
})

localStorage.setItem("lang", i18n.global.locale)

export default i18n
